import {
	whenConsentChanges,
	ONETRUST_CATEGORIES,
} from 'library/services/onetrust/await-consent'

// Sync OneTrust choices to Shopify Privacy API
// https://shopify.dev/docs/api/consent-tracking
export function syncOneTrustToShopifyPrivacy() {

	// Load Consent API
	window.Shopify.loadFeatures([{
		 name: 'consent-tracking-api',
		 version: '0.1',
	}], error => {
		if (error) return console.error('consent-tracking-api load', error)
		const privacyApi = window.Shopify.customerPrivacy

		// Watch for the OneTrust consent to change and update Shopify privacy API
		whenConsentChanges(enabledConsentIds => {

			// Get current consent as booleans
			const shopifyConsent = privacyApi.currentVisitorConsent()
			shopifyConsent.analytics = consentStrToBool(shopifyConsent.analytics)
			shopifyConsent.marketing = consentStrToBool(shopifyConsent.marketing)

			// Get the proposed new consent
			const newConsent = {
				analytics: enabledConsentIds.includes(ONETRUST_CATEGORIES.PERFORMANCE),
				marketing: enabledConsentIds.includes(ONETRUST_CATEGORIES.TARGETING),
			}

			// Update the consent if there were changes
			if (shopifyConsent.analytics !== newConsent.analytics
				|| shopifyConsent.marketing !== newConsent.marketing
			) {
				privacyApi.setTrackingConsent(newConsent, error => {
					if (error) console.error('setTrackingConsent', error)
				})
			}
		})
	})
}

// Convert Shopify's consent strings to boolean values for easier comparison
function consentStrToBool(value) {
	if (value == 'yes') return true
	if (value == 'no') return false
	else return null // Will be an empty string if not set
}
